import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { LinkGrid as LinkGridElement } from '../../../components/linkgrid/LinkGrid'
import type { NewsLandingPopularLinksFragment } from '@gql'

export type NewsLandingPopularLinkProps = {
    data: NewsLandingPopularLinksFragment[]
}

const StyledLinks = styled(LinkGridElement)`
  background-color: #f2f2f2 !important;
`

export const NewsLandingLinks: React.FC<PropsWithChildren<NewsLandingPopularLinkProps>> =({ data, ...props }) => {
  return (
    <LinkGridElement variant="dark" {...props}>
      {
        data.map((link, i)  => {
          return (
            <StyledLinks key={i} linkWrapper >
              <LinkGridElement link href={link.popularGuidePageLink?.url || '#'} target={link.popularGuidePageLink?.target === '_blank' ? '_blank' : '_self'}>{link.popularGuidePageTitle}</LinkGridElement>
            </StyledLinks>
          )
        })
      }
    </LinkGridElement>
  )
}